;$(function() {
  if(typeof $.fn.collapse == 'undefined') {
    throw new TypeError("modular/text-sidelist_toggleable needs boostrap v4 to run.");
  }

  $('.collapse').on('show.bs.collapse', function (event) {
    $('#'+ $(event.target).attr('id').replace('_content', '_teaser')).fadeOut('fast');
  })
});



//////////////////
// WEBPACK FOOTER
// ./js/modular/text-sidelist_toggleable.js
// module id = 7
// module chunks = 0